export default {
	title: "Fonctions",
	description: "Gérer les fonctions spirituelles et administratives du temple",
	searchPlaceholder: "Rechercher des fonctions...",
	create: "Nouvelle fonction",
	deleteConfirmation: "Êtes-vous sûr de vouloir supprimer la fonction {name} ?",
	deleteWarning: "Cette action est permanente. Toutes les affectations de personnes à cette fonction seront supprimées.",
	confirmDeleteMessage: "Êtes-vous sûr de vouloir supprimer cette fonction ? Cette action est irréversible.",
	name: "Nom",
	category: "Catégorie",
	personCount: "Personnes affectées",
	peopleCount: "Personnes",
	minimumJourney: "Parcours minimum",
	noRequirement: "Aucune exigence",
	noCategory: "Aucune catégorie",
	newCategory: "Nouvelle catégorie",
	minimumJourneyStage: "Étape minimum du parcours",
	minimumJourneyStageHint: "Étape minimum du parcours requise pour exercer cette fonction (optionnel)",
	status: {
		active: "Active",
		inactive: "Inactive",
		all: "Toutes",
	},
	empty: {
		description: "Enregistrez les fonctions spirituelles et administratives du temple",
		title: "Aucune fonction trouvée",
	},
	stats: {
		total: "Total",
		withPersons: "Avec des personnes",
		withoutPersons: "Sans personnes",
	},
	messages: {
		activated: "Fonction activée avec succès",
		deactivated: "Fonction désactivée avec succès",
		createError: "Erreur lors de la création de la fonction",
		deleteError: "Erreur lors de la suppression de la fonction",
		fetchError: "Erreur lors du chargement des fonctions",
		loadError: "Erreur lors du chargement des fonctions",
		saveError: "Erreur lors de l'enregistrement de la fonction",
		createSuccess: "Fonction créée avec succès",
		updateSuccess: "Fonction mise à jour avec succès",
		deleteSuccess: "Fonction supprimée avec succès",
	},
	addFunction: "Ajouter une fonction",
	selectFunction: "Sélectionner une fonction",
	requiredStage: "Étape requise",
	minimumJourneyStageRequired: "Étape minimum requise : {stage}",
	journeyStageNotMet: "L'étape actuelle ({current}) ne satisfait pas l'exigence minimum ({required})",
	noCurrentStage: "Aucune étape actuelle",
	currentJourneyStage: "Étape actuelle du parcours",
	function: "Fonction",
	notes: "Notes",
	noFunctions: "Aucune fonction affectée",
	since: "Depuis",
	deactivate: "Désactiver",
	reactivate: "Réactiver",
	endedAt: "Terminée le",
};
